<div *ngIf="shouldShowSimulateBar" class="simulate-bar d-flex justify-content-between align-items-center">
  <span
    class="icon-simulate ftmi-impersonate text-primary"
    role="img"
    [attr.aria-label]="'SIMULATE' | translate"
    [appTooltip]="'SIMULATE' | translate"
    placement="right"
  ></span>

  <div class="app-input-inline simulate-input">
    <label class="simulate-input-label" for="simulate-bar-user" id="simulate-bar-user-a11y-label">{{ 'SEARCH' | translate }}</label>
    <app-auto-complete
      inputId="simulate-bar-user"
      labelElementId="simulate-bar-user-a11y-label"
      [ariaLabel]="'SEARCH' | translate"
      (selectedItemChange)="onSelectChangeUser($event)"
      (searchChange)="onSearchChangeUser($event)"
      [itemsData]="users"
      [selectedItem]="form.controls.user.value"
    ></app-auto-complete>
  </div>

  <button type="button" (click)="onReturn()" class="btn btn-text">{{ 'RETURN' | translate }}</button>
</div>
